const tmIcon = String.fromCodePoint(0x02122);

export const asrStrings = {
  outsideAdvocate: `This concern was identified when you received your vehicle and is approved for repair, `+
  `our trusted warranty partner SilverRock${tmIcon} `+
  `will reach out via email within 48 hours with next steps. Please be sure to check your spam folder.`,
  altText: `This concern has been forwarded to SilverRock, our trusted warranty partner, for review. `+ 
  `SilverRock${tmIcon} will reach out within 24-48 hours via email with a decision and next steps.`
};
